import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output
} from "@angular/core";

interface OverflowDetectDirectiveConfig {
  disabled?: boolean;
  itemsSize: number;
  itemsCount: number;
}

@Directive({
  selector: "[overflowDetector]",
  standalone: false
})
export class OverflowDetectDirective implements AfterViewInit {
  @Input("overflowDetector")
  overflowDetectorConfig!: OverflowDetectDirectiveConfig;

  @Output()
  inside: EventEmitter<void> = new EventEmitter<void>(true);

  @Output()
  overflow: EventEmitter<void> = new EventEmitter<void>(true);

  constructor(private elementRef: ElementRef<HTMLElement>) {
    if (this.overflowDetectorConfig?.disabled) return;

    let doIt = -1;
    addEventListener("resize", () => {
      clearTimeout(doIt);
      doIt = window.setTimeout(() => this.checkAndEmit(), 250);
    });
  }

  ngAfterViewInit(): void {
    if (this.overflowDetectorConfig?.disabled) return;

    setTimeout(() => this.checkAndEmit(), 0);
  }

  checkAndEmit(): void {
    if (this.overflowDetectorConfig?.disabled) return;

    const { isOverflow, width } = checkIsOverflow(
      this.elementRef.nativeElement
    );
    if (isOverflow) {
      this.overflow.emit();
    } else {
      if (!isOverflow) {
        const finalSize =
          this.overflowDetectorConfig.itemsCount *
          this.overflowDetectorConfig.itemsSize;
        if (finalSize < width) {
          this.inside.emit();
        }
      }
    }
  }
}

function checkIsOverflow(element: HTMLElement): {
  isOverflow: boolean;
  width: number;
} {
  return {
    isOverflow: element.scrollWidth > element.clientWidth,
    width: element.clientWidth
  };
}
